import React, { useRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useHistory, useParams } from 'react-router-dom';
import { SubtractDown, SubtractRed } from 'assets/images/web-isn';
import { getHousingMaterialProducts } from '../../aboutIsn.api';
import { getQueryString } from 'utils/params';
import useFullPageLoader from '../../../commons/isn/useFullPageLoader';

function HousingMaterialMenu() {
  const { t } = useTranslation();
  const location = useLocation();
  const [isScrollUp, setIsScrollUp] = useState(false);
  const prevScrollY = useRef(0);
  const { language } = useParams();
  const [subMenu] = useState([]);
  const history = useHistory();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const menuItems = [
    {
      to: `/about-us/housing-material/overview`,
      name: t('about_isn.housing_material.lbl_overview'),
      active: location.pathname.includes(`/about-us/housing-material/overview`),
    },
    {
      to: `/about-us/housing-material/products`,
      name: t('about_isn.housing_material.lbl_products'),
      active: location.pathname.includes(`/about-us/housing-material/products`),
    },
    {
      to: `/about-us/housing-material/gallery`,
      name: t('about_isn.housing_material.lbl_gallery'),
      active: location.pathname.includes(`/about-us/housing-material/gallery`),
    },
  ];

  useEffect(() => {
    showLoader();
    getHousingMaterialProducts(getQueryString({ language })).then(res => {
      if (res && res.length > 0) {

        res.map(item => {

          var menu = {
            id: '',
            to: '',
            name: '',
            active: ''
          }

          menu.id = item.id
          menu.to = `/about-us/housing-material/products/` + item.id;
          menu.name = item.title
          menu.active = location.pathname.includes(`/about-us/housing-material/products/` + item.id)
          subMenu.push(menu)
          hideLoader();
          return subMenu;
        })
      }
    })
    window.scrollTo({ top: 0, behavior: 'smooth' });
    //eslint-disable-next-line
  }, [])

  const gotoPage = (event, link, id) => {
    event.preventDefault();
    history.push(link);
    subMenu.forEach(item => {
      item.active= false;
      if (item.id === id) {
        item.active= true;
      }
    });
    if (link.includes(location.pathname)) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  };

  const DropdownMenu = () => {
    return (
      <ul className={language === 'jp' ? 'dropdown-menu dropdown-menu-jp' : 'dropdown-menu'}>
        <li><a href='https://keisoudo.vn/' target='_blank'>Interior paint Keisoudo</a></li>
        {/*{subMenu.length > 0 ? subMenu.map((item, index) => (*/}
        {/*  <li key={index}>*/}
        {/*    {*/}
        {/*      <span*/}
        {/*        onClick={e => {*/}
        {/*          gotoPage(e, `/${language}` + item.to, item.id);*/}
        {/*        }}*/}
        {/*        className={`${item.active ? 'active_item none-text-decoration' : ''}`}*/}
        {/*      >*/}
        {/*        {item.name}*/}
        {/*      </span>*/}
        {/*    }*/}
        {/*  </li>*/}
        {/*)) : ''}*/}
      </ul>
    );
  };

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    prevScrollY.current >= 327 ? setIsScrollUp(true) : setIsScrollUp(false);
    prevScrollY.current = currentScrollY;
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line
  }, [prevScrollY]);

  return (
    <div id="housingMaterialMenu" className={`${isScrollUp ? 'housingMaterialMenu' : 'housingMaterialMenuHide'}`}>
      <div className="container">
        {menuItems.map((item, index) => {
          return (
            <li key={index}>
              {item.to === `/about-us/housing-material/products` ? (
                <div className={`menu-item right-space ${item.active ? 'active_item' : ''} types-menu-hover`}>
                  {item.name}
                  <img src={item.active ? SubtractRed : SubtractDown} alt="icon" style={{ padding: '5px' }}></img>
                  {DropdownMenu()}
                </div>
              ) : (
                <Link
                  to={`/${language}` + item.to}
                  className={`menu-item right-space ${item.active ? 'active_item' : ''}`}
                >
                  {item.name}
                </Link>
              )}
            </li>
          );
        })}
      </div>
      {loader}
    </div>
  );
}

export default HousingMaterialMenu;
